import React, { useState } from 'react';
import useCobroExternos from '../hooks/useCobroExternos';
import useHistorialExternos from '../hooks/useHistorialExternos';
import VistaHistorialDePagos from './VistaHistorialDePagos';
import VistaCobroExternos from './VistaCobroExternos';
import { rolDeSesion, esAdministrador, puedeValidarPago } from '../utilities/permisos';
import './CobroExternos.css';
import './PanelCobro.css';

const CobroExternos = ({ user }) => {
  const [vistaActual, setVistaActual] = useState('cobro');

  // 1. Instanciamos el Hook Principal de Cobros
  const cobroProps = useCobroExternos(user);

  // 2. Instanciamos el Hook de Historial de Pagos (ordenes pendientes para validar + pagos hechos)
  const historialProps = useHistorialExternos(user, cobroProps.externoSeleccionado);

  // Entidad para cabeceras del historial
  const infoEntidad = cobroProps.externos.find(e => e.matricula === cobroProps.externoSeleccionado) || {};

  // El Administrador (rol 1) consulta pendientes de cualquier plantel pero nunca valida pagos (ve los botones
  // deshabilitados); cualquier cajero real (rol 2 o 3) si puede.
  const rolCajero = rolDeSesion();

  // Renderizado Condicional del Router Interno
  if (vistaActual === 'historial') {
    return (
      <div style={{ marginTop: '20px', fontFamily: 'sans-serif' }}>
        <div className="catalogo-section" style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h2 style={{ color: '#003366', margin: '0 0 8px 0', fontSize: '22px' }}>Historial de Pagos de: {infoEntidad.nombre || 'Externo'}</h2>
            <p style={{ color: '#666', margin: 0, fontSize: '14px' }}>
              <strong>Matrícula:</strong> {infoEntidad.matricula} &nbsp;|&nbsp; <strong> Plantel:</strong> {user?.nombre_plantel}
            </p>
          </div>
          <button className="cobro-layout btn-logout" onClick={() => setVistaActual('cobro')} style={{ width: 'auto', padding: '12px 24px', backgroundColor: '#d9534f' }}>
            ← Volver al Cobro
          </button>
        </div>
        <VistaHistorialDePagos
          {...historialProps}
          cargando={historialProps.cargandoHistorial || historialProps.cargandoPendientes}
          pendientes={historialProps.datosPendientes}
          pagos={historialProps.datosHistorial}
          mostrarModalValidacion={historialProps.modalValidacion}
          puedeValidar={puedeValidarPago(rolCajero)}
          soloLectura={esAdministrador(rolCajero)}
        />
      </div>
    );
  }

  return (
    <VistaCobroExternos 
      {...cobroProps} 
      setVistaActual={(v) => { if (v === 'historial') historialProps.refrescarTodo(); setVistaActual(v); }}
    />
  );
};

export default CobroExternos;
